import { fetchClientJSON } from '../../../services/clientDataService';

export const SIMFIX_UPLOADS_PROJECT = 'SimFix';
export const SIMFIX_DEFAULT_CLIENT = 'default';

export const SIMFIX_FILES = {
  graph: 'grafi_per_scenario.json',
  los: 'los_per_scenario.json',
  grafici: 'scenario_grafici.json',
  descriptions: 'scenario_descriptions.json',
};

const fetchSimfixJSON = (clientType, file) =>
  fetchClientJSON(clientType, file, { project: SIMFIX_UPLOADS_PROJECT, trackLoading: false });

const loadClient = async (clientType) => {
  const [graph, los, grafici, descriptions] = await Promise.all([
    fetchSimfixJSON(clientType, SIMFIX_FILES.graph),
    fetchSimfixJSON(clientType, SIMFIX_FILES.los),
    fetchSimfixJSON(clientType, SIMFIX_FILES.grafici),
    fetchSimfixJSON(clientType, SIMFIX_FILES.descriptions).catch(() => ({})),
  ]);
  return { graph, los, grafici, descriptions: descriptions || {} };
};

/**
 * Loads the four SimFix datasets for a client from the uploads API
 * ({uploads}/api/browse/SimFix/{client}/{file}), falling back to the default client folder.
 */
export async function loadSimfixDataset(clientType) {
  const client = clientType || SIMFIX_DEFAULT_CLIENT;
  try {
    return await loadClient(client);
  } catch (err) {
    if (client === SIMFIX_DEFAULT_CLIENT) throw err;
    console.warn(`[SimFix] no data for "${client}", using "${SIMFIX_DEFAULT_CLIENT}":`, err?.message || err);
    return loadClient(SIMFIX_DEFAULT_CLIENT);
  }
}
